import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba9f4ec8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_base_contents_wrapper" }
const _hoisted_2 = { class: "entry_base_indicator_wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_base_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_title_text" }, "生年月日を教えてください")
], -1))
const _hoisted_4 = { class: "entry_base_input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "生年月日"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_6 = { class: "entry_base_input_item_dateofbirth" }
const _hoisted_7 = { class: "entry_base_button" }
const _hoisted_8 = { class: "entry_base_button_prev" }
const _hoisted_9 = { class: "entry_base_button_next" }

import { ref, computed, onMounted, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import { useField, useForm } from 'vee-validate';
import { object, string } from 'yup';
import { getMasterDataList, Master } from '@/api/entryMasterDataEndpoint';
import alertOnReload from '@/utils/alertOnReload';
import store from '@/store';
import Indicator from '@/components/Indicator.vue';
import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseYmdForm from '@/components/BaseYmdForm.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import VALIDATON_ERRORS from '@/constants/validationErrors';


export default /*#__PURE__*/_defineComponent({
  __name: 'BirthDateView',
  setup(__props) {

const schema = object({
  birthDate: string()
    .label('生年月日')
    .required()
    .matches(/^\d{4}-\d{2}-\d{2}$/, VALIDATON_ERRORS.REQUIRED)
});
const { meta, errors } = useForm({
  validationSchema: schema,
});

const { value: birthDate } = useField('birthDate', undefined, {
  initialValue: store.getters['userRegistration/birthDate'],
});

const router = useRouter();
const transitionPage = () => {
  store.commit('userRegistration/setBirthDate', birthDate.value);
  router.push({ name: 'b07' });
};
const transitionPreviousPage = () => {
  router.push({ name: 'b04' });
};

onBeforeMount(async () => {
  const token = store.getters['userRegistration/token'] as string;
  if (!token) {
    router.push({ name: 'b11' });
    return;
  }
});
alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 7,
          max: 8
        })
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(BaseYmdForm, {
            modelValue: _unref(birthDate),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(birthDate) ? (birthDate).value = $event : null)),
            placeholder: "2000-01-01",
            yearSort: "desc"
          }, null, 8, ["modelValue"])
        ])
      ]),
      (_unref(errors).birthDate)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            errors: [_unref(errors).birthDate]
          }, null, 8, ["errors"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(BaseButton, {
            onClick: transitionPage,
            theme: "primary",
            type: "button",
            disabled: !_unref(meta).valid
          }, {
            default: _withCtx(() => [
              _createTextVNode("次へ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}
}

})